/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AddUpdateFormModal_form$ref: FragmentReference;
declare export opaque type AddUpdateFormModal_form$fragmentType: AddUpdateFormModal_form$ref;
export type AddUpdateFormModal_form = {|
  +id: string,
  +name: string,
  +description: ?string,
  +$refType: AddUpdateFormModal_form$ref,
|};
export type AddUpdateFormModal_form$data = AddUpdateFormModal_form;
export type AddUpdateFormModal_form$key = {
  +$data?: AddUpdateFormModal_form$data,
  +$fragmentRefs: AddUpdateFormModal_form$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "AddUpdateFormModal_form",
  "type": "Form",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '40057083b97eb1adfb5ea10f4b3aa2af';
module.exports = node;
